import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as ArrowUpSvg } from '../../assets/arrow-up-icon.svg';

export const ArrowUpIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={ArrowUpSvg} {...props} />;
};
